import { Action } from '@ngrx/store';


export enum AdmUsersActionTypes {
  GET_ADM_USERS = '[ADM_USERS] GetUsers',
  SET_ADM_USERS = '[ADM_USERS] SetUsers',
  EDIT_ADM_USERS = '[ADM_USERS] EditUsers',
  DELETE_ADM_USERS = '[ADM_USERS] DeleteUsers',
  SUCESS_USERS = '[ADM_USERS] SuccessUsers',
  FAIL_USERS = '[ADM_USERS] FailUsers',
}

export class AdmGetUsers implements Action {
  readonly type = AdmUsersActionTypes.GET_ADM_USERS;
  constructor() {}
}

export class AdmSetUsers implements Action {
  readonly type = AdmUsersActionTypes.SET_ADM_USERS;
  constructor(public DatosUsuario: any) {}
}
export class AdmEditUsers implements Action {
  readonly type = AdmUsersActionTypes.EDIT_ADM_USERS;
  constructor(public DatosUsuario: any) {}
}

export class AdmDeleteUsers implements Action {
  readonly type = AdmUsersActionTypes.DELETE_ADM_USERS;
  constructor(public ObjDel: any) {}
}

export class AdmSuscesUsers implements Action {
  readonly type = AdmUsersActionTypes.SUCESS_USERS;
  constructor(public Respuesta: any , public TipoR: string) {}
}

export class AdmFailUsers implements Action {
  readonly type = AdmUsersActionTypes.FAIL_USERS;
  constructor(public Respuesta: any) {}
}


export type AdmUsersAcciones =
    | AdmGetUsers
    | AdmSetUsers
    | AdmEditUsers
    | AdmDeleteUsers
    | AdmSuscesUsers
    | AdmFailUsers;
